export interface IMonetaryInputProps {
  name?: string;
  title: string;
  value: string;
  currencySign: string;
  onChange: (value: string) => void;
  refreshChanges?: (value: any) => void;
  formatWithCommas?: boolean;
}

export function addCommasToNumberString(numberString: string) {
  const addCommas = (str: string) => str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const [integerPart, decimalPart] = numberString.split(".");

  if (decimalPart !== undefined) {
    if (decimalPart.length > 2) {
      const rounded = Number.parseFloat(numberString).toFixed(2);
      const [int, dec] = rounded.split(".");
      return `${addCommas(int)}.${dec}`;
    }

    return `${addCommas(integerPart)}.${decimalPart.padEnd(2, "0")}`;
  }

  return addCommas(integerPart);
}

export function removeCommasFromNumberString(numberString: string) {
  return numberString.replace(/[^0-9.-]/g, "");
}
